import { useIntl } from 'react-intl';

import { Alert } from '@mui/material';

export enum GenericErrorType {
  error = 'error',
  info = 'info',
}

export interface GenericErrorProps {
  type: GenericErrorType;
  intlIdTitle: string;
  intlProps?: { [key: string]: string };
}

export function GenericError({ type, intlIdTitle, intlProps }: GenericErrorProps) {
  const intl = useIntl();

  return (
    <Alert variant="filled" severity={type}>
      {intl.formatMessage({ id: intlIdTitle }, intlProps)}
    </Alert>
  );
}
